import { gql } from "@apollo/client";

export const SAVE_POLICY_DATA = gql`
  mutation savePolicyData($input: SavePolicyDataInput!) {
    savePolicyData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_OFFER_DATA = gql`
  mutation saveOfferData($input: SaveOfferDataInput!) {
    saveOfferData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const GENERATE_POLICY = gql`
  mutation generatePolicy($input: GeneratePolicyInput!) {
    generatePolicy(input: $input) {
      commandId
      correlationId
    }
  }
`;
